import { useState, useEffect } from "react";
import "./App.css";

import {
  BrowserRouter as Router,
  Routes,
  Route,
} from "react-router-dom";

import Home from './pages/index';
import About from './pages/about';

import Navbar from "./components/Navbar/Navbar";

function App() {

  const conversionFactor = 762; // Power Profiler US Average CO@e lbs/MWh

  // not really sure what this is but it directly relates to natty gas
  //  and we do some logic based on that
  const NATURAL_GAS_FACTOR = 53; 

  useEffect(() => {

    // Hide and show kwh or mpg depeneding on type of car fuel
    let mpg = document.getElementById('tblRow_vehicle_miles_per_gallon');
    let kwhm = document.getElementById('tblRow_vehicle_miles_per_kwh');
    let transEnergyRow = document.getElementById('transportationenergy-data-row');
    if(directVars["vehicle_fuel_type"] === 'electric' && (mpg && kwhm && transEnergyRow)){
      mpg.style.display = 'none';
      kwhm.style.display = 'table-row';
      transEnergyRow.style.display = 'table-row';
    }
    else if(mpg && kwhm && transEnergyRow){
      mpg.style.display = 'table-row';
      kwhm.style.display = 'none';

      transEnergyRow.style.display = 'none';
    }
    
  })
  //THESE STATE VARIABLES MUST MATCH THE IDS OF THE FIELDS IN THE DirectTableData.JSON FILE
  //. **Also must be string type
  // Set the default values for the calculator
  // 
  const [directVars, setDirectVars] = useState({
    "number_of_people" : 1,
    "house_size_sq_ft" : 700,
    "region": 1.26,
    "house_type": 1,
    "primary_fuel_heating": NATURAL_GAS_FACTOR,
    "percent_renewable_heating" : 0,
    "insulation" : "1.0",
    "thermostat" : "1.0",
    "energy_conserve" : 1.0,
    "hot_tub" : "1",
    "renewable_energy" : 0,
    "vehicle_miles_per_year" : 12000,
    "vehicle_fuel_type" : 'gas',
    "vehicle_miles_per_kwh" : 3.5,
    "vehicle_miles_per_gallon" : 21,
    "alone_in_car" : 100,
    "bus_mpy" : 0,
    "train_mpy" : 0,
    "airplane_mpy" : 0
  });

  const [indirectVars, setIndirectvars] = useState({
    "diet-type" : 1.5,
    "personal-consumption" : 3,
    "personal-service" : 3.5
  })

  const heatingEnergyFunction = () => {
    var energy;

    var kbbtu_sqft = 25

    const mmbtu_energy = (
      ( kbbtu_sqft * ( directVars.house_type ) ) / 1000 *
      ( directVars.house_size_sq_ft / directVars.number_of_people ) * 
      ( directVars.region ) *
      ( directVars.insulation ) * 
      ( directVars.thermostat )
    )

    energy = mmbtu_energy

    let heating_units = document.getElementById('space-heating-and-natural-gas_energy-result-units');
    if(heating_units) {
      heating_units.innerText = "MMBTU"
    }

    // If natural gas selected, convert to therms
    if(directVars.primary_fuel_heating.toString() === NATURAL_GAS_FACTOR.toString()){
      energy = mmbtu_energy * 10
      // If natural gas heating, show therms
      
      if(heating_units) {
        heating_units.innerText = "THERMS"
      }
    
    }

    return energy;
  }

  const heatingEmissionFunction = () => {

    let energy = heatingEnergyFunction();

    // If natural gas selected, convert to mmbtu
    if(directVars.primary_fuel_heating.toString() === NATURAL_GAS_FACTOR.toString()){
      energy = energy / 10
    }
    var emissions = energy * directVars.primary_fuel_heating / 1000;
  
    return emissions;
  }

  const electricEnergyFunction = () => {

    const thermostatElectricFactor = directVars.thermostat

    const regionElectricFactor = (function() {
      // These values have to match to the values from the DirectTableData.json file's region object
      switch (Number(directVars.region)) {
        case 1.16: 
          return 0.86;
        case 1.26:
          return 0.91;
        case 0.87:
          return 1.16;
        case 0.84:
          return 0.93;
        case 0.75:
          return 0.83
        default:

          console.log(directVars.region, typeof directVars.region)
          console.log("electricEnergyFunction: failed to find valid region value from data file")
          return;
          // throw Error("electricEnergyFunction: failed to find valid region value from data file")
      }
    })();

    const houseTypeElectricFactor = (function() {
      switch (Number(directVars.house_type)) {
        case 1.14:
          return 0.92;
        case 0.93:
          return 0.95;
        case 1:
          return 1.14;
        case 0.84:
          return 1.03;
        case 0.5:
          return 0.5;
        case 0.4:
          return 0.2;
        default:
          console.log(directVars.house_type, typeof directVars.house_type)
          console.log("electricEnergyFunction: failed to find valid housetype value from data file")
          return;
          // throw Error("electricEnergyFunction: failed to find valid region value from data file")
      }
    })();

    const sizeAdjustmentFactor = -0.974

    const energy = 
      ( ( sizeAdjustmentFactor * Math.log(directVars.house_size_sq_ft) + 11.579 ) * directVars.house_size_sq_ft )
      * ( directVars.energy_conserve ) 
      * ( directVars.hot_tub ) 
      * ( directVars.insulation ) 
      * ( thermostatElectricFactor )
      * ( regionElectricFactor )
      * ( houseTypeElectricFactor )
      / directVars.number_of_people

    return energy;

  }
  
  const electricEmissionFunction = () => {

    const energy = electricEnergyFunction();

    const mtco2 = ( conversionFactor / 1000 ) / 2200; // converted to metric tons/kwh

    const emissions = energy * ( 1 - directVars.renewable_energy / 100 ) * mtco2;
    
    return emissions;

  }

  const transportationEnergyFunction = () => {

    // kWh per Year
    return directVars["vehicle_miles_per_year"] / directVars["vehicle_miles_per_kwh"] 

  }
  const transportationEmissionFunction = () => {

    var autoTotal;

    if( directVars["vehicle_fuel_type"] !== 'electric' ) // calculate emissions from gas
      autoTotal = ( (directVars["vehicle_miles_per_year"] / directVars["vehicle_miles_per_gallon"] ) * 
        8.91/1000 * directVars["alone_in_car"] / 100 );

    else { // calculate emissions from energy
      let energy = transportationEnergyFunction();

      let mtco2 = ( conversionFactor / 1000 ) / 2200; // converted to metric tons/kwh

      autoTotal = energy * mtco2 * directVars["alone_in_car"] / 100;
    }

    const busTotal = directVars["bus_mpy"] * .17 / 1000;

    const trainTotal = directVars["train_mpy"] * 0.08 / 1000;

    const airplaneTotal = directVars["airplane_mpy"] * 0.18 / 1000;

    const emissions = autoTotal + busTotal + trainTotal + airplaneTotal;

    return emissions;
  }

  const dietFunction = () => {
    return indirectVars["diet-type"] * 1;
  }

  const consumptionFunction = () => {
    return indirectVars["personal-consumption"] * 1;
  }

  const servicesFunction = () => {
    console.log(indirectVars["personal-service"], "personal")
    return Number(indirectVars["personal-service"]);
  }

  const totalEmissions = 
        heatingEmissionFunction() + 
        electricEmissionFunction() + 
        transportationEmissionFunction() +
        dietFunction() +
        consumptionFunction() +
        servicesFunction();


  return ( 
    <Router>
      <Navbar />
      <Routes>
          <Route exact path="/" element={
            <Home 
              directVars={directVars} 
              setDirectVars={setDirectVars} 
              heatingEmissionFunction={heatingEmissionFunction} 
              heatingEnergyFunction={heatingEnergyFunction}
              electricEmissionFunction={electricEmissionFunction}
              electricEnergyFunction={electricEnergyFunction}
              transportationEmissionFunction={transportationEmissionFunction}
              transportationEnergyFunction={transportationEnergyFunction}
              indirectVars={indirectVars}
              setIndirectVars={setIndirectvars}
              dietFunction={dietFunction}
              consumptionFunction={consumptionFunction}
              servicesFunction={servicesFunction}
              totalEmissions={totalEmissions}
            /> 
          } />
          <Route path="/about" element={<About />} />
      </Routes>
    </Router>
  )
}

export default App;
